import React from 'react';
import Menu from '../Menu/Menu';

const Header = () => {
    return (
        <div>
            <Menu></Menu>
        </div>
    );
};

export default Header;